export { EccTable } from './src/ecc-table';
